<template>
  <div class="d-flex api-client-list-view-row api-client-item align-center">
    <div>
      <div class="pl-4">
        <span class="font-weight-medium">{{ item.name }}</span>
        <div v-if="item.scopes && item.scopes.length > 0" class="mt-1">
          <v-chip
            v-for="scope in item.scopes"
            :key="scope"
            color="light-blue-accent-4"
            size="small"
            variant="tonal"
            class="mr-1"
          >
            {{ formatScope(scope) }}
          </v-chip>
        </div>
      </div>
    </div>
    <div>
      <code class="text-caption">{{ item.client_id }}</code>
    </div>
    <div>
      <div style="overflow: hidden;">
        <span class="font-weight-medium">{{ item.user_name }}</span>
        <span v-if="item.user_email" class="text-caption d-block text-grey email-truncate">
          {{ item.user_email }}
        </span>
      </div>
    </div>
    <div>
      <v-chip
        :color="item.active ? 'light-blue-accent-4' : 'light-blue-accent-2'"
        size="small"
        variant="tonal"
      >
        {{ item.active ? $t('routes.apiClients.active') : $t('routes.apiClients.inactive') }}
      </v-chip>
    </div>
    <div>
      <span class="text-caption">{{ formatDate(item.created_at) }}</span>
    </div>
    <div>
      <v-menu v-if="$canControlTenantConfig()" v-model="showingMenu">
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            variant="text"
            width="32"
            height="32"
            rounded="circle"
            v-bind="props"
            data-cy="apiClient-item-menu"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list data-cy="apiClient-item-menu-list">
          <v-list-item @click="editClient" data-cy="apiClient-item-edit">
            <template v-slot:prepend>
              <v-icon size="small">mdi-pencil-outline</v-icon>
            </template>
            <v-list-item-title>
              {{ $t('routes.apiClients.edit') }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item @click="toggleStatus" data-cy="apiClient-item-toggleStatus">
            <template v-slot:prepend>
              <v-icon size="small">
                {{ item.active ? 'mdi-pause-circle-outline' : 'mdi-play-circle-outline' }}
              </v-icon>
            </template>
            <v-list-item-title>
              {{ item.active ? $t('routes.apiClients.disable') : $t('routes.apiClients.enable') }}
            </v-list-item-title>
          </v-list-item>

          <v-divider />

          <DeleteClientDialog
            :client="item"
            @clientDeleted="onClientDeleted"
          >
            <v-list-item data-cy="apiClient-item-delete" style="cursor: pointer;">
              <template v-slot:prepend>
                <v-icon size="small" color="error">mdi-delete-outline</v-icon>
              </template>
              <v-list-item-title class="text-error">
                {{ $t('routes.apiClients.delete') }}
              </v-list-item-title>
            </v-list-item>
          </DeleteClientDialog>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import DeleteClientDialog from './dialogs/DeleteClientDialog.vue'

export default {
  name: "ApiClientItem",
  components: {
    DeleteClientDialog,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ['deleteClient', 'toggleStatus', 'editClient'],
  data() {
    return {
      showingMenu: false,
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    formatScope(scope) {
      const [type, permission] = scope.split(':');
      const typeLabel = type.charAt(0).toUpperCase() + type.slice(1);
      const permLabel = permission.charAt(0).toUpperCase() + permission.slice(1);
      return `${typeLabel}: ${permLabel}`;
    },
    editClient() {
      this.showingMenu = false;
      this.$emit('editClient', this.item);
    },
    toggleStatus() {
      this.showingMenu = false;
      this.$emit('toggleStatus', {
        clientId: this.item.id,
        active: !this.item.active,
      });
    },
    onClientDeleted() {
      this.showingMenu = false;
      this.$emit('deleteClient', this.item.id);
    },
  },
}
</script>

<style scoped>
.api-client-item {
  min-height: 64px;
  border-radius: 8px;
  margin-bottom: 4px;
}

.v-theme--dark .api-client-item {
  background-color: #1e1e1e;
}

.v-theme--light .api-client-item {
  background-color: #fafafa;
}

.api-client-item:hover {
  opacity: 0.9;
}

.email-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
